import { render, staticRenderFns } from "./receiver-dialog.vue?vue&type=template&id=73196d39&"
import script from "./receiver-dialog.vue?vue&type=script&lang=js&"
export * from "./receiver-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports